export default {
    "": "Trống",
    "testing": "Đang test",
    "success": "Test thành công",
    "failed": "Test failed",
}
